import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {Grid, Table, Tooltip, OverlayTrigger} from 'react-bootstrap';
import { 
  updateStockInput, 
  updateDbStockInput, 
  updateDbSectorInput, 
  getTickerInfo, 
  updateSummaryInput, 
  updateDbQuarterSummary, 
  getChartInfo,
  getTickerNewsInfo, 
  toggleTickerstrikethrough,
} from '../../actions';
import TickerModal from '../../components/TickerModal/TickerModal';
import SectorWeightSetModal from "../../components/SectorWeightSetModal/SectorWeightSetModal";
import PortfolioStatsModal from "../../components/PortfolioStatsModal/PortfolioStatsModal";
import TaskBar from './TaskBar/TaskBar';
import { calc, calcWeightedAvgs } from './Helpers';
import ShowLoading from '../../HOC/ShowLoading';
import SubNav from '../../components/SubNav/SubNav';

import TableRow from './Editable/TableRow';
import TableHeader from './Editable/TableHeader';

import ReadonlyTableRow from './Readonly/TableRow';
import ReadonlyTableHeader from './Readonly/TableHeader';

import './Dashboard.css';

const sections = [
  { sectorTitle: 'Discretionary (XLY)', sectorSymbol: 'XLY', sector: 1 },
  { sectorTitle: 'Staples (XLP)', sectorSymbol: 'XLP', sector: 2 },
  { sectorTitle: 'Energy (XLE)', sectorSymbol: 'XLE', sector: 3 },
  { sectorTitle: 'Financials (XLF)', sectorSymbol: 'XLF', sector: 4 },
  { sectorTitle: 'Real Estate Investment Trusts (XLRE)', sectorSymbol: 'XLRE', sector: 5 },
  { sectorTitle: 'Healthcare (XLV)', sectorSymbol: 'XLV', sector: 6 },
  { sectorTitle: 'Industrials (XLI)', sectorSymbol: 'XLI', sector: 7 },
  { sectorTitle: 'Technology (XLK)', sectorSymbol: 'XLK', sector: 8 },
  { sectorTitle: 'Materials (XLB)', sectorSymbol: 'XLB', sector: 9 },
  { sectorTitle: 'Utilities (XLU)', sectorSymbol: 'XLU', sector: 10 },
  { sectorTitle: 'Communication Services (XLC)', sectorSymbol: 'XLC', sector: 11 },
];

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTickerModal: false,
      showSectorWeightSetModal: false,
      showPortfolioStatsModal: false,
      currentTickerInfo: [],
      customizations:[]
    };
  }

  openModal = (data) => {
    // console.log(data, 'openModal');
    const { symbol } = data;
    this.props.getChartInfo({ symbol, range: '1m' });
    this.props.getTickerNewsInfo({ symbol });
    this.setState({ currentTickerInfo: data, showTickerModal: true }); 
  }
  openWeightModal= (data)=>{
    this.setState({customizations:data, showSectorWeightSetModal: true });
  }
  openPortfolioStatsModal=(d) => {
    this.setState({showPortfolioStatsModal: true });
  }

  closeModal = (name) => {
    if(name==="showSectorWeightSetModal"){
      this.setState({showSectorWeightSetModal: false});
      this.props.getTickerInfo();
    }
    this.setState({ [name]: false });
  }

  hide = () => {
    if (this.props.settings.hideColumns) {
      return { display: 'none' };
    } else {
      return null;
    }
  }

  sectionsMap = () => {
    const { tickerInfo, sectorInfo, benchmarkInfo, quarterInfo, customizations } = this.props.user;
    // console.log(customizations)
    const newTickerInfo = calc({ tickerInfo, sectorInfo, benchmarkInfo, quarterInfo,customizations });
    // console.log(newTickerInfo,"newticker");
    // console.log("newTickerInfo", newTickerInfo);
    const activePortfolioId = this.props.session.activePortfolioUser.portfolio_id;
    // this.setState({ customizations: customizations });
    const userPrivilege = this.props.session.activePortfolioUser.privilege;

    return sections.map((item, index) => {

      let theme = '';
      if (index % 2 === 0) {
        theme = 'even-row';
      } else { 
        theme = 'odd-row';
      }

      if (userPrivilege === 'readonly') {
        return [
          <ReadonlyTableHeader 
            key={item.sectorSymbol}
            hide={this.hide}
            theme={theme}
            title={item.sectorTitle}
            sectorSymbol={item.sectorSymbol}
            sectorInfo={newTickerInfo.sectorInfo}
            openModal={this.openModal}

          />,
          <ReadonlyTableRow
            key={item.sector}
            hide={this.hide}            
            theme={theme}
            sector={item.sector}
            tickerInfo={newTickerInfo.tickerInfo}
            openModal={this.openModal}
            customizations={newTickerInfo.customizations}

          />
        ]
      } else {
        return [
          <TableHeader 
            key={item.sectorSymbol}
            hide={this.hide}
            theme={theme}
            title={item.sectorTitle}
            sectorSymbol={item.sectorSymbol}
            sectorInfo={newTickerInfo.sectorInfo}
            updateStockInput={this.props.updateStockInput} 
            updateDbSectorInput={this.props.updateDbSectorInput} 
            activePortfolioId={activePortfolioId}
            openModal={this.openModal}

          />,
          <TableRow
            key={item.sector}
            hide={this.hide}            
            theme={theme}
            sector={item.sector}
            tickerInfo={newTickerInfo.tickerInfo}
            customizations={newTickerInfo.customizations}
            updateStockInput={this.props.updateStockInput}
            updateDbStockInput={this.props.updateDbStockInput}
            openModal={this.openModal}
            activePortfolioId={activePortfolioId}
            toggleTickerstrikethrough={this.props.toggleTickerstrikethrough} />
        ]
      }
    });
  }

  render() {  

    const isHidden = this.props.settings.hideColumns;
    const userPrivilege = this.props.session.activePortfolioUser.privilege;
    const editableCol = userPrivilege === 'readonly' ? null : 'editable-col';

    const { tickerInfo,customizations } = this.props.user;
    const currentHoldings = tickerInfo.length
    console.log(this.props.user,"ticker")
    const { marketCapAvg, PERatioAvg, betaAvg, EPSAvg, dividendAvg,sectionsData
    } = calcWeightedAvgs({ tickerInfo});
    const sectionsTitles = sections.map(section => section.sectorTitle);

    // const tooltipWeightedAvgs = (
    //   <Tooltip id="tooltipWeightedAvgs">
    //     <Table className="stock-averages-table">
    //       <thead>
    //         <tr>
    //           <th colSpan="2">Averages</th>
    //         </tr>
    //       </thead>
    //       <tbody>
    //         <tr>
    //           <td>EPS</td>
    //           <td>{EPSAvg}</td>
    //         </tr>
    //         <tr>
    //           <td>Beta</td>
    //           <td>{betaAvg}</td>
    //         </tr>
    //         <tr>
    //           <td>PE Ratio</td>
    //           <td>{PERatioAvg}</td>
    //         </tr>
    //         <tr>
    //           <td>Dividend</td>
    //           <td>{dividendAvg}</td>
    //         </tr>
    //         <tr>
    //           <td>Market Cap</td>
    //           <td>{marketCapAvg}</td>
    //         </tr>
    //       </tbody>
    //     </Table>
    //   </Tooltip>
    // );

    return (
      <Fragment>
        <SubNav />
        <Grid fluid className="dashboard">

          <TaskBar

            quarterInfo={this.props.user.quarterInfo}
            benchmarkInfo={this.props.user.benchmarkInfo} />

          <Table responsive bordered id="dashboard-table" style={{ fontSize: this.props.settings.fontSize }} className="is-hidden">
            <thead>
              <tr className="sections">
                {/*<th colSpan="12">*/}
                <th colSpan="10">
                  {/*<OverlayTrigger placement="right" overlay={tooltipWeightedAvgs}>*/}
                    <span style={{ cursor: 'pointer' }} onClick={()=>this.openPortfolioStatsModal()}>Stock Technicals</span>
                  {/*</OverlayTrigger>*/}
                  <span className="last-updated">Last Updated: {this.props.session.lastUpdateTime}</span>
                </th>      
                <th colSpan="3">Sector Technicals</th>
                <th colSpan="3">Sector Weightings</th>
                <th colSpan={isHidden ? 3 : 4}>Daily Performance</th>
                <th colSpan={isHidden ? 5 : 12}>Quarter Performance</th>
                <th colSpan="1">YTD</th>
                <th colSpan={isHidden ? 1 : 4}>Other</th>
              </tr>

              <tr className="headers">

                <th>ML PRICE</th>
                <th>UPSIDE</th>
                <th>50 SMA</th>
                <th className={editableCol}>RES.</th>
                <th className={editableCol}>SUP.</th>  

                <th style={{ cursor: 'pointer' }}  onClick={()=>this.openWeightModal()}>WEIGHT</th>
                <th>TICKER</th>            
                <th>PRICE</th>
                <th>%CHG</th>

                <th>FMP</th>
                {/*<th>MS</th>*/}
                {/*<th>S&amp;P</th>*/}

                <th className={editableCol}>RES.</th>
                <th>TICKER</th>
                <th className={editableCol}>SUP.</th>

                <th>SG</th>
                <th>vs S&amp;P</th>
                <th>S&amp;P</th>

                <th>SCM SECTOR</th>
                <th>ETF TODAY</th>
                <th className={editableCol} style={this.hide()}>QUARTER</th>
                <th>LAG/ LEAD</th>
                
                <th>ALPHA PERF</th>
                <th style={this.hide()}>STOCK CB</th>
                <th className={editableCol} style={this.hide()}>ADJ CB</th>
                <th style={this.hide()}>SECTOR CB</th>
                <th className={editableCol} style={this.hide()}>ADJ CB</th>
                <th>SG PERF</th>
                <th>ETF PERF</th>
                <th className={editableCol} style={this.hide()}>1ST QTR</th>
                <th className={editableCol} style={this.hide()}>2ND QTR</th>
                <th className={editableCol} style={this.hide()}>3RD QTR</th>
                <th>LAG/ LEAD</th>
                <th>WHY</th>

                <th>TOTAL</th>

                <th className={editableCol} style={this.hide()}>SHARES</th>
                <th style={this.hide()}>WORTH</th>

                <th className={editableCol}>DECK</th>
                <th className={editableCol} style={this.hide()}>COMMENTS</th>
              </tr>
            </thead>        
            <tbody>

              <TickerModal 
                showTickerModal={this.state.showTickerModal} 
                closeModal={this.closeModal} 
                currentTickerInfo={this.state.currentTickerInfo} 
                getChartInfo={this.props.getChartInfo} 
                chartInfo={this.props.user.chartInfo} 
                tickerNewsInfo={this.props.user.tickerNewsInfo} />
              <SectorWeightSetModal
                  customizations={customizations}
                  showSectorWeightSetModal={this.state.showSectorWeightSetModal}
                  closeModal={this.closeModal}
                  />
              <PortfolioStatsModal
                  showPortfolioStatsModal={this.state.showPortfolioStatsModal}
                  closeModal={this.closeModal}
                  EPSAvg={EPSAvg}
                  betaAvg={betaAvg}
                  PERatioAvg={PERatioAvg}
                  dividendAvg={dividendAvg}
                  marketCapAvg={marketCapAvg}
                  currentHoldings={currentHoldings|| 0}
                  sections={sectionsTitles}
                  sectionsData={sectionsData}
                  />

              {this.sectionsMap()}          
          
            </tbody>
          </Table>

        </Grid>
      </Fragment>
    );
  }
}

function mapStateToProps({ user, auth, settings, session }) {
  return {
    user,
    auth,
    settings,
    session
  };
}

export default ShowLoading(connect(mapStateToProps, { 
  updateStockInput, 
  updateDbStockInput, 
  updateDbSectorInput, 
  getTickerInfo, 
  updateSummaryInput, 
  updateDbQuarterSummary, 
  getChartInfo, 
  getTickerNewsInfo, 
  toggleTickerstrikethrough
})(Dashboard));